import { render, staticRenderFns } from "./MessageCard.vue?vue&type=template&id=ace8e31e&scoped=true"
import script from "./MessageCard.vue?vue&type=script&lang=js"
export * from "./MessageCard.vue?vue&type=script&lang=js"
import style0 from "./MessageCard.vue?vue&type=style&index=0&id=ace8e31e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace8e31e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ace8e31e')) {
      api.createRecord('ace8e31e', component.options)
    } else {
      api.reload('ace8e31e', component.options)
    }
    module.hot.accept("./MessageCard.vue?vue&type=template&id=ace8e31e&scoped=true", function () {
      api.rerender('ace8e31e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImChat/components/MessageCard.vue"
export default component.exports